import RouteRegister from "@/plugins/router/services/RouteRegister"
import routers from "@/modules/complaints/routers"

export default {
    install: () => {
        RouteRegister.handle(routers)
    }
}
